/**
 * Whether `people` is allowed by a diners-available list.
 * Empty / missing list means no diner restriction.
 */
export default function slotSupportsPeople(
  dinersAvailable: Array<number | string> | null | undefined,
  people?: number | null,
): boolean {
  const normalizedDiners = dinersAvailable?.map((value) => String(value));

  return (
    !people ||
    !normalizedDiners ||
    normalizedDiners.length === 0 ||
    normalizedDiners.includes(String(people))
  );
}
